import React from "react";
import Checkbox from "./Checkbox";

class ShowInTwdCheckbox extends React.PureComponent {
  render() {
    const { isInTwd, toggleSetTwd } = this.props;

    return (
      <div className="flex cursor-pointer items-center">
        <Checkbox isChecked={isInTwd} onChange={toggleSetTwd}></Checkbox>
        <div
          className="ml-1 align-middle text-sm font-semibold text-gray-600 hover:text-gray-700"
          onClick={toggleSetTwd}
        >
          Show in TWD
        </div>
      </div>
    );
  }
}

export default ShowInTwdCheckbox;
